<template>
    <div class="modules-show-filters">
        <b-button
            class="btn-after-chevron-up d-sm-none btn-modules-show-filter-toggle"
            v-b-toggle.modules-filter
            block
            variant="primary">
            Filter
        </b-button>
        <b-collapse
            class="modules-filter-collapse"
            id="modules-filter"
            visible>
            <design-2021-module-checkbox-filter-component
                title="Type"
                :options="tagsOptions"
                :selected-in="filters.tags"
                @update-filter="updateFilter">
            </design-2021-module-checkbox-filter-component>

            <design-2021-module-checkbox-filter-component
                :title="$t('modules.hours')"
                :options="hourOptions"
                :selected-in="filters.hours"
                @update-filter="updateFilter">
            </design-2021-module-checkbox-filter-component>

            <design-2021-module-checkbox-filter-component
                :title="$t('modules.registration')"
                :options="registerOptions"
                :selected-in="filters.registered"
                @update-filter="updateFilter">
            </design-2021-module-checkbox-filter-component>

            <div class="clear-modules-filter">
                <b-button
                    class="btn-clear-filters"
                    variant="primary"
                    @click="updateFilter('', 'reset')"
                    ><i class="btn-eraser"></i>{{ $t('modules.reset_filters') }}
                </b-button>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import moment from 'moment/moment';

export default {
    name: 'design-2021-module-show-filters-component',
    props: {
        modulesIn: Array,
        educationLevelsIn: Array,
    },

    data() {
        return {
            tagsOptions: [],
            filters: {
                tags: [],
                hours: [],
                registered: [1, 2],
            },
            hourOptions: [],
            registerOptions: [
                {
                    value: 1,
                    text: 'Open',
                },
                {
                    value: 0,
                    text: this.$t('modules.closed'),
                },
                {
                    value: 2,
                    text: this.$t('modules.future'),
                },
            ],
            moduleFilterStorage: `module-filters-${this.$authUser.id}`,
        };
    },

    created() {
        if (localStorage.getItem(this.moduleFilterStorage)) {
            const filterStatuses = JSON.parse(localStorage.getItem(this.moduleFilterStorage));
            const now = moment();

            if (now.diff(filterStatuses.expiry, 'hours') > 2) {
                const filterStatus = {
                    filters: this.filters,
                    expiry: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                };
                localStorage.setItem(this.moduleFilterStorage, JSON.stringify(filterStatus));
            } else {
                const filterStatus = JSON.parse(localStorage.getItem(this.moduleFilterStorage));
                this.filters = filterStatus.filters;
                this.$emit('update-filters', this.filters);
            }
        } else {
            const filterStatus = {
                filters: this.filters,
                expiry: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            };
            localStorage.setItem(this.moduleFilterStorage, JSON.stringify(filterStatus));
        }
    },

    mounted() {
        this.getTags();
        this.getHours();
        this.$emit('update-filters', this.filters);
    },

    methods: {
        getHours() {
            const hours = [];

            if (this.modulesIn.length) {
                for (const module of this.modulesIn) {
                    for (const module_date of module.module_dates) {
                        hours.push(module_date);
                    }
                }
            }

            const arrayUniqueByKey = [...new Map(hours.map((item) => [item['duration'], item])).values()];

            this.hourOptions = arrayUniqueByKey
                .map((hour) => {
                    return {
                        value: hour.module_period.duration,
                        text: hour.module_period.duration,
                    };
                })
                .sort((a, b) => a.value - b.value);
        },

        getTags() {
            const tags = [];

            if (this.modulesIn.length) {
                for (const module of this.modulesIn) {
                    for (const module_tag of module.module_tags) {
                        tags.push(module_tag);
                    }
                }
            }

            const arrayUniqueByKey = [...new Map(tags.map((item) => [item['id'], item])).values()];

            this.tagsOptions = arrayUniqueByKey.map((tag) => {
                return {
                    value: tag.id,
                    text: tag.name,
                };
            });
        },

        updateFilter(checked, filterType) {
            if (filterType === 'type') {
                this.filters.tags = checked;
            }

            if (filterType === 'uren') {
                this.filters.hours = checked;
            }

            if (filterType === 'inschrijving') {
                this.filters.registered = checked;
            }

            if (filterType === 'reset') {
                this.filters.hours = [];
                this.filters.tags = [];
                this.filters.registered = [1, 2];
            }

            const filterStatus = {
                filters: this.filters,
                expiry: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            };

            localStorage.setItem(this.moduleFilterStorage, JSON.stringify(filterStatus));

            this.$emit('update-filters', this.filters);
        },
    },

    watch: {
        modulesIn: function () {
            this.getTags();
            this.getHours();
            this.$emit('update-filters', this.filters);
        },
    },
};
</script>

<style scoped lang="scss">
.modules-show-filters {
    padding-bottom: map-get($grid-gutter-spacing, 'fifteen');

    .btn-modules-show-filter-toggle {
        margin-bottom: map-get($grid-gutter-spacing, 'ten');

        &:after {
            transition: transform 0.4s ease;
        }

        &.not-collapsed {
            &:after {
                transform: rotate(180deg);
            }
        }
    }
}

.clear-modules-filter {
    display: flex;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .btn-clear-filters {
        display: flex;
        flex: 1;
        flex-direction: row;
        line-height: 1;
        justify-content: center;

        i {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .modules-show-filters {
        max-width: 300px;
    }

    .clear-modules-filter {
        .btn-clear-filters {
            flex: 0 0 auto;
        }
    }
}
</style>
